<template>
    <div class="media-slider-wrapper max-w-[800px] mx-auto group/photos mb-8">

        <Splide class="relative overflow-hidden rounded-md" :has-track="false" :options="{ rewind: true, speed: 650, easing: 'cubic-bezier(0.45, 0, 0.55, 1)', autoplay: true, pauseOnHover: true, pauseOnFocus: true, interval: 4000, pagination: false }" aria-label="My Favorite Images" v-if="media && media.length">

            <SplideTrack>
               <SplideSlide v-for="item in media" :key="item">
                    <div class="photo-slide z-[1] relative w-full aspect-[4/3] sm:aspect-[16/8]">
                        <img :src="getImage(item)" class="w-full h-full object-cover" />



                        <router-link class="photos-cover absolute bottom-0 left-0 w-full flex items-stretch p-3 group/link" v-if="item.media.type == 'photo_set'" :to="`/media/${item.media.post_name}`">

                                <div class="flex flex-shrink-0 text-[.85rem] whitespace-nowrap font-medium gap-2 py-2.5 sm:py-5 flex items-center justify-center sm:px-12 px-5 text-white hover:bg-cyan-800 hover:bg-opacity-90 transition-colors duration-300 bg-cyan-900 rounded-l-md whitespace-nowrap" >
                                    <RectangleStackIcon class="sm:w-6 sm:h-6 w-4 h-4 transition-colors duration-300 group-hover/link:text-[#EC7B7B]" />
                                    <span class="leading-[1em] tracking-wide whitespace-nowrap sm:block hidden">VIEW SLIDESHOW</span>
                                    <span class="leading-[1em] tracking-wide whitespace-nowrap sm:hidden">VIEW</span>
                                </div>

                                <div class="flex-grow text-white py-3 sm:py-4 px-5 flex flex-col justify-center bg-black bg-opacity-70 rounded-r-md">
                                    <h3 class="sm:text-lg font-medium antialiased mb-0.5 leading-tight" v-if="item.headline" v-html="item.headline"></h3>
                                    <h4 class="text-sm text-gray-200 sm:flex items-center gap-3 font-medium antialiased leading-tight hidden">
                                        <span v-html="item.media.post_title"></span>
                                        <span>&bull;</span>
                                        <span>{{ item.media.photo_set.length }} Slides</span>
                                    </h4>
                                </div>
                        </router-link>

                        <router-link class="videos-cover absolute bottom-0 left-0 w-full flex items-stretch p-3 z-[5] group/link" v-if="item.media.type == 'video'" :to="`/media/${item.media.post_name}`">

                            <div class="flex flex-shrink-0 text-[.85rem] whitespace-nowrap font-medium gap-2 py-2 sm:py-5 flex items-center justify-center sm:px-12 px-5 text-white hover:bg-cyan-800 hover:bg-opacity-90 transition-colors duration-300 bg-cyan-900 rounded-l-md">
                                <PlayIcon class="sm:w-6 sm:h-6 w-4 h-4 transition-colors duration-300 group-hover/link:text-[#EC7B7B]" />
                                <span class="leading-[1em] tracking-wide sm:block hidden">PLAY VIDEO</span>
                                <span class="leading-[1em] tracking-wide sm:hidden">PLAY</span>
                            </div>

                            <div class="flex-grow text-white py-2.5 sm:py-4 px-5 flex flex-col justify-center bg-black bg-opacity-70  rounded-r-md">
                                <h3 class="sm:text-lg font-medium antialiased leading-snug" v-if="item.headline" v-html="item.headline"></h3>
                            </div>
                        </router-link>

                        <a class="brochures-cover absolute bottom-0 sm:bottom-auto w-full sm:top-0 left-0 sm:h-full sm:w-2/5 flex sm:flex-col flex-row-reverse items-stretch p-3.5 group/link" v-if="item.media.type == 'brochure'" target="_blank" :href="item.media.brochure.file">


                            <div class="flex-grow text-white sm:px-8 sm:pt-7 md:pt-12 sm:pb-8 px-5 py-2.5 flex flex-col bg-black bg-opacity-70 rounded-r-md sm:rounded-r-none sm:rounded-t-md ">

                                    <h3 class="sm:text-[1.65rem] font-medium antialiased leading-snug sm:leading-8 sm:min-h-[5rem] sm:mb-3" v-if="item.headline" v-html="item.headline"></h3>

                                    <h4 class="line-clamp-2 text-gray-200 text-[.85rem] uppercase md:mb-1.5 font-semibold antialiased leading-snug mt-auto hidden sm:block" v-html="item.media.post_title"></h4>
                                    <h3 class="text-[.83rem] text-gray-300 antialiased italic hidden md:block" v-text="item.media.description"></h3>


                            </div>


                            <div class="flex flex-shrink-0 text-[.85rem] whitespace-nowrap font-medium gap-2 sm:py-5 flex items-center justify-center py-2.5 px-5 sm:px-12 text-white hover:bg-cyan-800 hover:bg-opacity-90 transition-colors duration-300 bg-cyan-900 sm:rounded-b-md sm:rounded-tl-none rounded-l-md">
                                <NewspaperIcon class="sm:w-6 sm:h-6 w-4 h-4 transition-colors duration-300 group-hover/link:text-[#EC7B7B]" />
                                <span class="leading-[1em] tracking-wide hidden sm:block">DOWNLOAD BROCHURE</span>
                                <span class="text-xs leading-[1em] tracking-wide sm:hidden">DOWNLOAD</span>
                            </div>
                        </a>
                    </div>
                </SplideSlide>
            </SplideTrack>

            <div class="splide__arrows z-20 absolute pointer-events-none w-full top-1/2 left-0 -translate-y-1/2 flex justify-between px-1.5 opacity-0 scale-110 transition-all ease-out duration-300 group-hover/photos:scale-100 group-hover/photos:opacity-100" :class="{'!hidden': media.length < 2}">
                <button class="splide__arrow splide__arrow--prev pointer-events-auto text-white flex w-10 h-10 flex items-center justify-center opacity-70 transition-opacity duration-500 hover:opacity-100">
                    <svg class="w-8 h-8" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M31 36L19 24L31 12" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                </button>
                <button class="splide__arrow splide__arrow--next pointer-events-auto text-white flex w-10 h-10 flex items-center justify-center opacity-70 transition-opacity duration-500 hover:opacity-100">
                    <svg class="w-8 h-8" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12L31 24L19 36" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>

            </Splide>

    </div>
</template>
<script setup>
    import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
    import { onMounted, ref, computed } from 'vue';
    import { RouterLink } from 'vue-router';
    import { NewspaperIcon, RectangleStackIcon, PlayIcon } from '@heroicons/vue/24/solid'

    const props = defineProps({
        mediaType: {
            type: String,
            default: 'photo'
        },
        featuredArray: {
            default: []
        }
    })


    const media = computed(() => {
        if ( props.featuredArray && props.featuredArray.length ) {
            return JSON.parse( props.featuredArray );
        }
        return [];
    })

    const getImage = (item) => {
        console.log('item', item.override_image, item)
        if ( item.override_image )  {
            return item.custom_image.sizes.large;
        }
        if (item.media.type == 'photo_set') return item.media.photo_set[0].large;
        if (item.media.type == 'video') return item.media.video.large;
        if (item.media.type == 'brochure') return item.media.brochure.large;
        return null
    }

</script>
<style lang="postcss">

    @import url('@css/drive.css');
</style>
